var _ = require("underscore");

var SavePointData = function (data) {
    this.type = data["type"];
    this.version = data["version"];
    this.name = data["name"];
    this.description = data["description"];
    this.time = data["time"];
    this.ot = data["ot"];   //required for closure compiler
    this.thumbnail = data["thumbnail"];
    this.source = data["source"];
    this.not_from_sharejs = data["not_from_sharejs"];
    // _.extend(this, data);
    this.time = new Date(this.time);
    this.name = this.name || "Version " + this.version;
    this.description = this.description || "No description";
    this.source = this.source && new SourceData(this.source);
};

var SourceData = function (data) {
    this.type = data["type"];
    this.files = data["files"];
    // _.extend(this, data);
    this.files = this.files || [];
    this.files = this.files.map(function(file) { return new FileData(file);});
};

var FileData = function (data) {
    this.type = data["type"];
    this.source = data["source"];
    // _.extend(this, data);
};

module.exports = SavePointData;
